import { useEffect, useRef, useState } from "react";
import { maskItem, URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Row, Col, Card, CardHeader, CardBody, Table } from "reactstrap";
import { H4, H6, H3, H2, Btn } from "../../AbstractElements";
import { formatDate, formatPrice, generateRandomNumber, getWeekOfMonth, supprimerBalises, truncateText } from "../../utils/helper/helpers";
import { Link } from "react-router-dom";
import html2pdf from "html2pdf.js";



interface PDVInterface {
    [key: string]: any;
}

const usePDVListe = (refresh: boolean): PDVInterface[] => {
    const [PDV, setPDV] = useState<PDVInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchPDV = async () => {
            axios.get(`${URL_API}/pdv/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {
                if (response.status === 201) {
                    setPDV(response.data.pdv_secondaire);
                }

            }).catch(error => {
                if (error.response.status === 400) {
                    toast.info(error.response.data.message);
                }
            })
        };
        fetchPDV();
    }, [refresh]);

    return PDV;
};
export default usePDVListe;

export const cardPDV = ({ value }: { value: { [key: string]: any } }) => {
    let total_ventes = 0;
    let total_paiement = 0;

    // Utilisation de `reduce` pour améliorer la lisibilité et l'efficacité
    value.forEach((item: any) => {
        total_ventes += Number(item.montant_total);  // Conversion de la chaîne en nombre
        total_paiement += Number(item.total_paiement);  // Conversion de la chaîne en nombre
    });
    return (
        <Row>
            <Col sm="4">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{ value.length }</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Total PDV
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-users-alt-2 f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-success">
                    <CardHeader className="pb-4 bg-light-success">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{maskItem(formatPrice(total_ventes))}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Montant Total
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-bank-transfer f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-danger">
                    <CardHeader className="pb-4 bg-light-danger">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{maskItem(formatPrice(total_ventes - total_paiement))}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3 text-white">
                                    Reste À Payer
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-visa-electron f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>

        </Row>
    )
};

export const deleteClient = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/client/delete/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("PDV Secondaire supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}